import { render, staticRenderFns } from "./PriceHighlight.vue?vue&type=template&id=2bd3f918"
import script from "./PriceHighlight.vue?vue&type=script&lang=js"
export * from "./PriceHighlight.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports